const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getResponsiveWidgetScale = (
  dims,
  {
    baseWidth = 280,
    baseHeight = 180,
    min = 0.78,
    max = 2.5,
  } = {},
) => {
  const width = Number(dims?.width);
  const height = Number(dims?.height);

  if (!Number.isFinite(width) || width <= 0 || !Number.isFinite(height) || height <= 0) {
    return 1;
  }

  const widthRatio = width / baseWidth;
  const heightRatio = height / baseHeight;
  const rawScale = Math.sqrt(Math.max(0.15, widthRatio) * Math.max(0.15, heightRatio));

  return clamp(rawScale, min, max);
};

export const getResponsiveWidgetVars = (dims) => {
  const scale = getResponsiveWidgetScale(dims);
  const size = (base, min, max) =>
    `calc(${clamp(base * scale, min, max)}px * var(--font-size-multiplier, 1))`;

  return {
    "--widget-responsive-text-scale": String(scale),
    "--widget-responsive-title-size": size(16, 12, 44),
    "--widget-responsive-body-size": size(14, 11, 32),
    "--widget-responsive-small-size": size(11, 9, 22),
    "--widget-responsive-value-size": size(42, 18, 110),
    "--widget-responsive-unit-size": size(30, 12, 72),
  };
};
